import { UI_NAME } from './dropdown.constants';

export const CLASS_NAMES = {
  root: UI_NAME
};
